"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function coerceObjectsNullsToUndefined(obj) {
    return Object.keys(obj).reduce((newObj, key) => {
        const value = obj[key];
        newObj[key] = value === null ? undefined : value;
        return newObj;
    }, {});
}
exports.default = coerceObjectsNullsToUndefined;
//# sourceMappingURL=coerce-object-nulls-to-undefined.js.map